import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import GetUrlFromPicid from "shared/util/GetUrlFromPicid";

import "./Photo.scss";

const Photo = ({ picid, photos, caption }) => {
	// Sometimes we get these as a picid. See: PhotoLiker.jsx
	const picUrl = photos ? photos.large : GetUrlFromPicid(picid);
	const style = picUrl ? { backgroundImage: `url(${picUrl})` } : undefined;

	return (
		<div
			className={classnames("profile-comment-photo-widget", {
				"profile-comment-photo-widget--fade": caption,
			})}
			style={style}
		>
			{caption && (
				<span className="profile-comment-photo-widget-caption">{caption}</span>
			)}
		</div>
	);
};

Photo.propTypes = {
	caption: PropTypes.string,
	photos: PropTypes.shape({
		large: PropTypes.string,
		medium: PropTypes.string,
		small: PropTypes.string,
		original: PropTypes.string,
	}),
	picid: PropTypes.string,
};

Photo.defaultProps = {
	caption: null,
	photos: null,
	picid: null,
};

export default Photo;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileComment/Photo.jsx